import {createContext, ReactNode, useState} from 'react';

// Define the shape of the context
interface TokenContextType {
  token?: string | null;
  setNewToken: (new_token: string) => void;
  removeToken: () => void;
}

// Create the context.
export const TokenContext = createContext<TokenContextType | undefined>(
  undefined
);

// Create a UserContextProvider component
export const TokenContextProvider = ({ children }: { children: ReactNode }) => {
  const searchParams = new URLSearchParams(location.search);
  const tokenId = parseInt(searchParams.get('authToken'));
  //Initialize context state with a "null" user
  const [token, setToken] = useState(localStorage.getItem('token'));

  const saveToken = (new_token: string) => {
    setToken(new_token);
    localStorage.setItem('token', new_token);
  };

  const deleteToken = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  return (
    <TokenContext.Provider
      value={{
        token,
        setNewToken: saveToken,
        removeToken: deleteToken
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

export default TokenContextProvider;
